import { Chart as ChartJS } from 'chart.js';
import { Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale, Filler, BarElement,
	ArcElement, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, LogarithmicScale } from 'chart.js'

let chartRegistered = false

export function useChart() {
	if (!chartRegistered) {
		ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale, Filler,
			BarElement, ArcElement, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, LogarithmicScale)
		chartRegistered = true;
	}
	return { ChartJS }
}
